import { submitEnvelope } from '@/store/api'
import { EventBus } from '@/utils/event-bus'
import store from '@/store'
import i18n from '@/locales'

const nextActionUtil = () => {
  const isEnvelopeDone = store.getters.isEnvelopeComplete()
  const isDocumentDone = store.getters.isDocumentDone()
  const nextField = store.getters.nextField()
  const activeFieldId = store.getters.activeFieldId

  if (isEnvelopeDone && activeFieldId) {
    store.commit('setActiveField', { activeFieldId: null })
  } else if (isEnvelopeDone) {
    if (window.IS_PREVIEW) {
      alert(i18n.t('footer.signPreviewWarning'))
    } else if (store.getters.isWidget) {
      EventBus.$emit('openModal', 'widgetPartyInfoModal')
    } else {
      EventBus.$emit('loading')

      submitEnvelope({ store }).then((response) => {
        EventBus.$emit('submitEnvelope', { response })
      })
    }
  } else if (isDocumentDone) {
    store.commit('setActiveField', { activeFieldId: null })
    store.dispatch('nextDocument')
    EventBus.$emit('nextDocument')
  } else {
    store.commit('setActiveField', { activeFieldId: nextField.id })
    EventBus.$emit('scrollBody')
    if (nextField.type === 'checkbox') {
      EventBus.$emit('highlightField', { field: nextField })
    }
  }
}

export default nextActionUtil
